export interface Episode {
  episode: number;
  title: string;
  airDate: string;
  duration: string;
  summary: string;
  plot: string;
}

export interface CastMember {
  id: string;
  name: string;
  role: string;
  avatar: string;
  roleDesc: string;
  bio: string;
  works: string;
  episodes: number[];
}

export interface Recommendation {
  id: string;
  title: string;
  poster: string;
  summary: string;
  reason: string;
  year: string;
  genre: string;
}

export const episodePosters: string[] = [
  'https://readdy.ai/api/search-image?query=Cinematic%20still%20of%20a%20young%20woman%20walking%20through%20a%20bustling%20city%20street%20at%20golden%20hour%20carrying%20a%20suitcase%2C%20warm%20backlight%2C%20shallow%20depth%20of%20field%2C%20film%20photography%2C%20high%20detail&width=1200&height=675&seq=ep-poster-01&orientation=landscape',
  'https://readdy.ai/api/search-image?query=Cinematic%20still%20of%20a%20cozy%20shared%20apartment%20living%20room%20in%20the%20evening%20with%20warm%20lamp%20light%20and%20plants%2C%20calm%20domestic%20atmosphere%2C%20shallow%20depth%20of%20field%2C%20film%20photography%2C%20high%20detail&width=1200&height=675&seq=ep-poster-02&orientation=landscape',
  'https://readdy.ai/api/search-image?query=Cinematic%20still%20of%20rain%20on%20a%20city%20bus%20stop%20with%20blurred%20umbrella%20silhouettes%20and%20wet%20pavement%20reflections%2C%20moody%20blue%20evening%20light%2C%20film%20photography%2C%20high%20detail&width=1200&height=675&seq=ep-poster-03&orientation=landscape',
  'https://readdy.ai/api/search-image?query=Cinematic%20still%20of%20an%20old%20rural%20house%20courtyard%20at%20dusk%20with%20warm%20lantern%20glow%20and%20neatly%20stacked%20firewood%2C%20nostalgic%20warm%20tones%2C%20film%20photography%2C%20high%20detail&width=1200&height=675&seq=ep-poster-04&orientation=landscape',
  'https://readdy.ai/api/search-image?query=Cinematic%20still%20of%20a%20family%20gathered%20around%20a%20dinner%20table%20at%20night%20with%20steaming%20dishes%20and%20soft%20amber%20light%2C%20warm%20cozy%20atmosphere%2C%20film%20photography%2C%20high%20detail&width=1200&height=675&seq=ep-poster-05&orientation=landscape',
  'https://readdy.ai/api/search-image?query=Cinematic%20still%20of%20a%20rooftop%20at%20sunrise%20with%20two%20silhouettes%20watching%20the%20dawn%20over%20a%20sleeping%20city%2C%20warm%20orange%20sky%20gradient%2C%20hopeful%20mood%2C%20film%20photography%2C%20high%20detail&width=1200&height=675&seq=ep-poster-06&orientation=landscape',
  'https://readdy.ai/api/search-image?query=Cinematic%20still%20of%20a%20neighborhood%20night%20market%20with%20warm%20string%20lights%20and%20people%20chatting%2C%20lively%20cozy%20evening%20atmosphere%2C%20film%20photography%2C%20high%20detail&width=1200&height=675&seq=ep-poster-07&orientation=landscape',
  'https://readdy.ai/api/search-image?query=Cinematic%20still%20of%20a%20young%20woman%20sitting%20by%20a%20bright%20window%20writing%20in%20a%20notebook%20at%20night%2C%20soft%20warm%20desk%20lamp%20light%2C%20quiet%20reflective%20mood%2C%20film%20photography%2C%20high%20detail&width=1200&height=675&seq=ep-poster-08&orientation=landscape',
];

export const dramaInfo = {
  name: '善良的小姨子',
  subtitle: '一部关于亲情、成长与善意的都市家庭剧',
  intro:
    '《善良的小姨子》以都市生活为背景，讲述了年轻姑娘苏念在姐姐意外住院后，走进这个陌生家庭，用真诚与善意化解重重误会的温暖故事。剧集在细腻的家庭日常中铺陈情感，在平凡小事里照见人性的光亮。',
  meta: {
    year: '2024',
    region: '中国大陆',
    genre: '都市 / 家庭 / 情感',
    totalEpisodes: '24 集',
    status: '已完结',
    rating: '8.6',
  },
};

export const episodes: Episode[] = [
  {
    episode: 1,
    title: '初到大城市的行李箱',
    airDate: '2024-03-01',
    duration: '45 分钟',
    summary: '苏念拖着行李箱来到大城市，第一站就撞进了姐姐家的风波里。',
    plot: '苏念刚从老家来到大城市，满心期待投奔姐姐苏瑶。谁知刚到小区门口，就撞见姐夫周明轩因工作烦心事与姐姐争执。她拖着旧行李箱站在楼道口，进退两难。一次笨拙的帮忙意外打翻了邻居的快递，也让她结识了热心又爱操心的李慧兰阿姨。夜幕降临时，苏念在阳台上默默整理行李，姐姐递来一杯热茶，姐妹俩说起小时候的往事，为后续的相处埋下温暖的伏笔。',
  },
  {
    episode: 2,
    title: '意外的合租',
    airDate: '2024-03-02',
    duration: '44 分钟',
    summary: '为了不给姐姐添麻烦，苏念提出自己找房子，却意外住进了陆则言的合租房。',
    plot: '苏念不愿长期打扰姐姐一家，坚持要自己租房。找房途中她遇上房东陆则言，一个说话直白却心地不坏的年轻人。两人因租金押金的问题几番拌嘴，最终以合租的方式达成协议。搬家当天，苏念把房间布置得井井有条，还顺手帮楼下摊主打理生意，她的善意被邻里看在眼里，也为她在这个陌生城市赢得第一份友情。',
  },
  {
    episode: 3,
    title: '冰箱里的便当',
    airDate: '2024-03-03',
    duration: '43 分钟',
    summary: '苏念每天多带一份便当，悄悄放在姐夫加班的桌上，引发一场误会。',
    plot: '苏念发现姐夫周明轩常常加班到深夜，便每天多准备一份便当放进公司冰箱。同事误以为是有女生追求周明轩，消息传回家里，姐姐心里泛起了疙瘩。苏念本想解释，却发现越描越黑。关键时刻李慧兰阿姨出面帮忙澄清，一场风波平息，但姐妹之间第一次出现了微妙的隔阂，也让苏念开始思考善意的边界。',
  },
  {
    episode: 4,
    title: '雨夜的伞',
    airDate: '2024-03-04',
    duration: '45 分钟',
    summary: '一场大雨中，苏念把唯一的伞留给陌生人，自己淋成落汤鸡。',
    plot: '城市突降暴雨，苏念在公交站把伞塞给一位抱着孩子的陌生母亲，自己冒雨跑回家。夜里她发起高烧，陆则言慌慌张张地煮姜汤、找药，嘴上嫌弃却动作麻利。第二天姐姐赶来照顾她，看着病床上仍笑着说没事的妹妹，姐姐既心疼又愧疚。这一场雨，让苏念和身边人的关系悄悄靠近了一步。',
  },
  {
    episode: 5,
    title: '误会与解释',
    airDate: '2024-03-05',
    duration: '44 分钟',
    summary: '一张旧照片让姐姐怀疑苏念与姐夫的关系，家宴气氛降到冰点。',
    plot: '家庭聚餐上，姐姐无意中翻到一张苏念与周明轩同框的旧照片，当场变了脸色。饭桌上的沉默让苏念如坐针毡。她鼓起勇气讲出照片的来历——那只是当年姐夫去老家接姐姐时顺手拍下的合影。误会解开，姐姐红着眼眶道歉，苏念却笑着说"一家人不用说这个"。这段插曲让彼此更懂得坦诚的重要。',
  },
  {
    episode: 6,
    title: '旧照片的秘密',
    airDate: '2024-03-06',
    duration: '43 分钟',
    summary: '照片背后的旧信封，牵出母亲当年未曾说出口的牵挂。',
    plot: '翻找旧物时，苏念在照片背面发现一个泛黄的信封，里面是母亲写给姐姐却始终没有寄出的信。信中母亲担心姐姐远嫁受委屈，字里行间全是放不下的牵挂。姐妹俩读着读着都哭了。她们决定把这份心意转达给父亲苏建国，一向嘴硬的父亲沉默良久，最终说出"是爸当年太固执"。这一集把家庭情感的暗线彻底铺开。',
  },
  {
    episode: 7,
    title: '小雅的心事',
    airDate: '2024-03-07',
    duration: '44 分钟',
    summary: '侄女小雅在学校被同学排挤，苏念用一个约定打开她的心门。',
    plot: '姐姐的女儿小雅最近闷闷不乐，成绩也明显下滑。苏念没有追问，而是带她去公园喂鸽子、吃冰淇淋，慢慢聊出真相——小雅因为口音被同学取笑。苏念讲起自己刚来城市时的窘迫，两人拉钩约定"每天记录一件开心的事"。小雅重新抬起头，苏念也第一次真切感受到"小姨"这个身份的分量。',
  },
  {
    episode: 8,
    title: '加班的深夜',
    airDate: '2024-03-08',
    duration: '45 分钟',
    summary: '周明轩项目受阻，苏念用外行的思路点醒了陷入僵局的他。',
    plot: '周明轩负责的项目连续受挫，整个人焦躁易怒，家里气氛紧张。苏念送夜宵时听他抱怨，随口的一句"为什么不换个顺序试试"竟让他豁然开朗。方案修改后顺利通过，周明轩第一次认真对这个小姨子说了声谢谢。他也开始明白，善意和理解有时比能力更能解决困局。',
  },
  {
    episode: 9,
    title: '邻居的请求',
    airDate: '2024-03-09',
    duration: '43 分钟',
    summary: '李慧兰阿姨请苏念帮忙照看独居老父亲，她一口答应。',
    plot: '李慧兰的父亲独自住在老小区，近来身体不好却不肯搬来同住。李慧兰为难之际，苏念主动提出每天下班去陪老人聊聊天。老人在她的陪伴下渐渐开朗，还教她做家乡菜。这段忘年交让苏念体会到，善意从来不是单方面的付出，而是一种双向的温暖。',
  },
  {
    episode: 10,
    title: '第一次落泪',
    airDate: '2024-03-10',
    duration: '44 分钟',
    summary: '一直笑着的苏念，在深夜电话里第一次没忍住眼泪。',
    plot: '工作上的一次失误让苏念被同事误解，她强撑着笑脸一整天，回到家却接到老家的电话，得知母亲身体不适。深夜她坐在飘窗边给老家打电话，说着说着声音哽咽。陆则言隔着墙听见，默默煮了碗面放在门口。第二天清晨，苏念擦干眼泪重新出发，展现出坚强外表下的柔软一面。',
  },
  {
    episode: 11,
    title: '姐姐的秘密',
    airDate: '2024-03-11',
    duration: '45 分钟',
    summary: '姐姐体检查出问题却瞒着所有人，被苏念无意中发现。',
    plot: '苏念整理房间时发现姐姐的体检报告，上面标着需要复查的提示。她追问之下，姐姐终于承认自己怕家人担心而选择隐瞒。苏念又生气又心疼，坚持陪姐姐去医院复查。复查结果并无大碍，姐妹俩在医院走廊相拥而泣。这一集让"善良"从单向的付出，变成彼此坦诚的守护。',
  },
  {
    episode: 12,
    title: '聚光灯下',
    airDate: '2024-03-12',
    duration: '43 分钟',
    summary: '社区晚会临时缺主持人，苏念硬着头皮顶上舞台。',
    plot: '社区筹备中秋晚会，原定主持人临阵缺席。大家一筹莫展时，苏念被推上了舞台。她紧张得手心冒汗，却在看到台下熟悉的面孔后慢慢放松，用真诚的主持打动了全场。演出结束时掌声雷动，苏念第一次发现，原来自己也有站在聚光灯下的勇气。',
  },
  {
    episode: 13,
    title: '争执与和解',
    airDate: '2024-03-13',
    duration: '44 分钟',
    summary: '因为一笔钱，苏念与陆则言爆发了最激烈的一次争吵。',
    plot: '陆则言的旧友向他借钱，他念旧情想答应，苏念却担心他被骗，两人为此争得面红耳赤。冷战几天后，真相浮出水面——那位旧友确实处境艰难。苏念主动提出用更稳妥的方式帮忙，两人在深夜的路边摊和解。这一集把两个年轻人从斗嘴到并肩的过程刻画得细腻动人。',
  },
  {
    episode: 14,
    title: '老家的来信',
    airDate: '2024-03-14',
    duration: '45 分钟',
    summary: '父亲苏建国来信，字里行间是笨拙却深沉的父爱。',
    plot: '苏念收到父亲寄来的包裹，里面是家乡的腌菜和一封手写信。信写得歪歪扭扭，却句句都在问姐妹俩吃得好不好、穿得暖不暖。苏念把信念给姐姐听，两人又笑又哭。她们决定趁假期回一趟老家，把那些年没能说出口的话好好说清楚。',
  },
  {
    episode: 15,
    title: '回家的路',
    airDate: '2024-03-15',
    duration: '46 分钟',
    summary: '姐妹俩一起回老家，父女三人在老屋前解开了多年的心结。',
    plot: '回到老家，姐妹俩看到父亲把院子收拾得干干净净，饭桌上摆满了她们爱吃的菜。晚饭后三人坐在老屋前的门槛上，父亲终于说出当年反对姐姐远嫁的歉意。多年的心结在夜色里一点点松开。这趟回家的路，让这个家庭重新找回了完整的温度。',
  },
  {
    episode: 16,
    title: '小雅的舞台',
    airDate: '2024-03-16',
    duration: '43 分钟',
    summary: '小雅参加朗诵比赛，苏念陪她克服了临场紧张。',
    plot: '小雅报名参加学校朗诵比赛，赛前却紧张得想放弃。苏念陪她一遍遍练习，还把"每天记录一件开心的事"的本子送给她当幸运符。比赛当天小雅站上舞台，虽然开头卡了一下，但很快稳住，完整地念完了整段。台下苏念比谁都用力地鼓掌。',
  },
  {
    episode: 17,
    title: '风波再起',
    airDate: '2024-03-17',
    duration: '44 分钟',
    summary: '小区里传出关于苏念的流言，她却选择用行动回应。',
    plot: '苏念帮陆则言旧友的事被邻居传得走样，流言四起。面对指指点点，苏念没有争辩，而是照常帮楼下的独居老人买菜、帮李慧兰阿姨照看父亲。时间一长，流言不攻自破，邻居们反倒对她竖起大拇指。这一集生动诠释了"清者自清"的从容。',
  },
  {
    episode: 18,
    title: '深夜的谈话',
    airDate: '2024-03-18',
    duration: '45 分钟',
    summary: '苏念和周明轩在天台上聊了很久，关于家庭与责任。',
    plot: '项目庆功宴后，周明轩独自在天台吹风，苏念陪他坐了一会儿。两人从工作聊到家庭，周明轩坦言自己一度把压力带回家，亏欠了妻子和小雅。苏念没有说教，只讲了老家父母的故事。这段坦诚的深夜谈话，让姐夫真正开始学着做一个温柔的家人。',
  },
  {
    episode: 19,
    title: '一起看日出',
    airDate: '2024-03-19',
    duration: '43 分钟',
    summary: '一家人相约看日出，在晨光里许下新的心愿。',
    plot: '苏念提议全家去城郊看日出。凌晨出发时大家哈欠连天，等太阳一点点跃出地平线，所有人都安静下来。姐姐握住妹妹的手，小雅许愿成绩进步，周明轩说想多陪家人。苏念望着漫天霞光，第一次觉得这座城市真正成了自己的家。',
  },
  {
    episode: 20,
    title: '善意的回响',
    airDate: '2024-03-20',
    duration: '44 分钟',
    summary: '曾经被苏念帮助过的人，纷纷在她困难时伸出援手。',
    plot: '苏念所在的店铺遇上经营困难，面临关门。正当她一筹莫展时，被她和姐姐帮助过的邻居们纷纷赶来——有人帮忙转发招揽顾客，有人拿出自己的手艺帮她办市集。善意像涟漪一样一圈圈荡开，最终汇聚成让她站稳脚跟的力量。这一集是全剧情感的高潮。',
  },
  {
    episode: 21,
    title: '心动的征兆',
    airDate: '2024-03-21',
    duration: '45 分钟',
    summary: '陆则言的一句"留下来吧"，让苏念心里泛起了涟漪。',
    plot: '合租合同到期，苏念犹豫要不要搬走。陆则言嘴上说着"随便你"，却默默把她的房间重新刷了漆。搬家前夜，他终于说出一句"留下来吧"。苏念没有立刻回答，却在第二天把行李箱推回了原位。两人相视一笑，一切尽在不言中。',
  },
  {
    episode: 22,
    title: '姐姐的选择',
    airDate: '2024-03-22',
    duration: '44 分钟',
    summary: '姐姐想重返职场，苏念成了她最坚定的支持者。',
    plot: '姐姐提起多年未做的工作，既向往又顾虑。苏念鼓励她去尝试，还主动承担起接送小雅的任务。面试那天，苏念陪姐姐买衣服、化妆，比她还紧张。姐姐拿到录用通知时，第一个电话打给了妹妹。这一集展现了姐妹之间互相成全的美好。',
  },
  {
    episode: 23,
    title: '临别的礼物',
    airDate: '2024-03-23',
    duration: '45 分钟',
    summary: '陆则言要出差半年，临别时送给苏念一份特别的礼物。',
    plot: '陆则言接到外地项目，要离开半年。出发前他送给苏念一个手写的本子，里面记着他们从合租第一天到如今的所有小事。苏念翻着一页页密密麻麻的字迹，眼眶湿润。她回赠了一张全家福。分别不是结束，而是两人关系新的开始。',
  },
  {
    episode: 24,
    title: '善良的小姨子',
    airDate: '2024-03-24',
    duration: '48 分钟',
    summary: '大结局：苏念用善良治愈了一个家，也被这个家温柔地拥抱。',
    plot: '半年后，一家人在新整理好的小院里过中秋。姐姐工作顺利，小雅考出了好成绩，父亲也搬来同住，连陆则言都赶了回来。饭桌上大家轮流向苏念道谢，她却说"是你们先接纳了我"。片尾，苏念站在阳台上望着万家灯火，笑着在心里说：善良，从来都不会被辜负。全剧在温暖中收束。',
  },
];

export const castList: CastMember[] = [
  {
    id: 'su-nian',
    name: '林晚晴',
    role: '苏念 · 善良的小姨子',
    avatar:
      'https://readdy.ai/api/search-image?query=Elegant%20warm%20portrait%20of%20a%20young%20Chinese%20actress%20with%20soft%20natural%20smile%2C%20light%20knitwear%2C%20gentle%20studio%20lighting%2C%20muted%20beige%20background%2C%20editorial%20casting%20photography%2C%20high%20detail&width=600&height=800&seq=cast-sunian-01&orientation=portrait',
    roleDesc:
      '全剧核心人物。刚离开老家来到大城市的年轻姑娘，性格温和却内心坚韧。她用真诚与善意走进姐姐的家庭，在一次次误会与和解中，成为这个家不可或缺的一部分。',
    bio: '青年演员，毕业于知名戏剧学院表演系。以细腻自然的表演风格著称，擅长刻画平凡生活中的人物温度，曾出演多部都市家庭题材作品。',
    works: '代表作品：《暖阳小巷》《春分以后》《回家的方向》',
    episodes: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24],
  },
  {
    id: 'zhou-mingxuan',
    name: '陈子谦',
    role: '周明轩 · 姐夫',
    avatar:
      'https://readdy.ai/api/search-image?query=Professional%20portrait%20of%20a%20Chinese%20man%20in%20his%20thirties%20wearing%20a%20simple%20white%20shirt%2C%20calm%20expression%2C%20soft%20neutral%20studio%20lighting%2C%20warm%20gray%20background%2C%20editorial%20photography%2C%20high%20detail&width=600&height=800&seq=cast-mingxuan-02&orientation=portrait',
    roleDesc:
      '苏念的姐夫，工作认真却不懂表达情绪的都市白领。起初因压力把小情绪带回家，在苏念的影响下逐渐学会温柔地对待家人，是全剧成长弧线最明显的人物之一。',
    bio: '实力派青年演员，擅长演绎内心复杂的现代都市男性角色。作品以现实主义题材见长，表演克制而有层次。',
    works: '代表作品：《城市之光》《深夜编辑部》《半程》',
    episodes: [1, 3, 5, 8, 11, 14, 15, 18, 19, 20, 22, 24],
  },
  {
    id: 'su-yao',
    name: '苏婉婷',
    role: '苏瑶 · 姐姐',
    avatar:
      'https://readdy.ai/api/search-image?query=Elegant%20portrait%20of%20a%20Chinese%20woman%20in%20her%20thirties%20with%20warm%20gentle%20expression%2C%20soft%20cream%20blouse%2C%20natural%20window%20light%2C%20muted%20warm%20background%2C%20editorial%20photography%2C%20high%20detail&width=600&height=800&seq=cast-suyao-03&orientation=portrait',
    roleDesc:
      '苏念的姐姐，外表干练、内心柔软的职场母亲。独自经营的焦虑与对家人的牵挂交织，她与妹妹从生疏到彼此依靠，撑起了全剧最动人的姐妹情。',
    bio: '资深实力女演员，塑造过多个深入人心的母亲与职场女性形象。表演真挚动人，善于用细节传递人物情感。',
    works: '代表作品：《我们的四季》《城南旧事新篇》《灯火可亲》',
    episodes: [1, 2, 4, 5, 6, 10, 11, 13, 14, 15, 19, 20, 22, 24],
  },
  {
    id: 'lu-zeyan',
    name: '陆则言',
    role: '陆则言 · 合租室友',
    avatar:
      'https://readdy.ai/api/search-image?query=Casual%20portrait%20of%20a%20young%20Chinese%20man%20in%20a%20denim%20jacket%2C%20relaxed%20confident%20smile%2C%20soft%20studio%20lighting%2C%20muted%20blue%20gray%20background%2C%20editorial%20photography%2C%20high%20detail&width=600&height=800&seq=cast-zeyan-04&orientation=portrait',
    roleDesc:
      '苏念的合租室友，说话直白、刀子嘴豆腐心。从最初的斗嘴室友，到默默守护苏念的那个人，他与苏念的感情线是全剧最轻松温暖的支线。',
    bio: '新生代男演员，气质清爽，擅长塑造都市青年形象。表演自然松弛，节奏感强，在轻喜剧与温情戏之间转换自如。',
    works: '代表作品：《街角的咖啡店》《夏日来信》《我们仨》',
    episodes: [2, 4, 10, 13, 17, 21, 23, 24],
  },
  {
    id: 'li-hulian',
    name: '沈亦柔',
    role: '李慧兰 · 热心邻居',
    avatar:
      'https://readdy.ai/api/search-image?query=Warm%20portrait%20of%20a%20kind%20middle-aged%20Chinese%20woman%20with%20gentle%20caring%20smile%2C%20simple%20cardigan%2C%20soft%20daylight%2C%20warm%20beige%20background%2C%20editorial%20photography%2C%20high%20detail&width=600&height=800&seq=cast-huilan-05&orientation=portrait',
    roleDesc:
      '小区里的热心阿姨，爱操心也最讲义气。她是苏念在城市里的第一位长辈朋友，多次在关键时刻为苏念化解误会，是全剧"邻里温情"的化身。',
    bio: '资深戏骨，长期活跃于家庭题材影视作品。擅长塑造生活气息浓厚的小人物，表演亲切自然，深受观众喜爱。',
    works: '代表作品：《家属院的故事》《妈妈的菜谱》《胡同人家》',
    episodes: [1, 3, 9, 17, 20, 24],
  },
  {
    id: 'xiao-ya',
    name: '张若宁',
    role: '小雅 · 侄女',
    avatar:
      'https://readdy.ai/api/search-image?query=Bright%20portrait%20of%20a%20teenage%20Chinese%20girl%20with%20braids%20and%20cheerful%20expression%2C%20school%20uniform%2C%20soft%20studio%20lighting%2C%20light%20warm%20background%2C%20editorial%20photography%2C%20high%20detail&width=600&height=800&seq=cast-xiaoya-06&orientation=portrait',
    roleDesc:
      '苏瑶与周明轩的女儿，小学高年级学生。因为口音被同学取笑而变得沉默，在苏念的陪伴下重新找回自信，是苏念与这个家建立情感的第一个纽带。',
    bio: '儿童演员，灵气十足，表演真挚不刻意。曾在多部家庭剧中出演，被观众称为"最有观众缘的小演员"。',
    works: '代表作品：《教室里的春天》《小镇少年》《放学路上》',
    episodes: [1, 2, 7, 16, 19, 22, 24],
  },
  {
    id: 'su-jianguo',
    name: '高子宸',
    role: '苏建国 · 父亲',
    avatar:
      'https://readdy.ai/api/search-image?query=Portrait%20of%20a%20dignified%20older%20Chinese%20man%20with%20gray%20hair%20and%20kind%20stern%20eyes%2C%20simple%20dark%20jacket%2C%20soft%20studio%20lighting%2C%20muted%20earth%20background%2C%20editorial%20photography%2C%20high%20detail&width=600&height=800&seq=cast-jianguo-07&orientation=portrait',
    roleDesc:
      '苏念与苏瑶的父亲，沉默寡言、嘴硬心软。当年曾反对女儿远嫁，多年的愧疚在女儿们回家时终于说出口，是全剧父爱线的关键人物。',
    bio: '老戏骨，从艺数十年，塑造过大量父亲形象。表演厚重内敛，一个眼神便能传递千言万语，是剧组公认的"定海神针"。',
    works: '代表作品：《父亲的渡口》《老屋》《归途列车》',
    episodes: [6, 14, 15, 19, 24],
  },
  {
    id: 'wang-yazhi',
    name: '王雅芝',
    role: '周母 · 周明轩母亲',
    avatar:
      'https://readdy.ai/api/search-image?query=Elegant%20portrait%20of%20a%20poised%20older%20Chinese%20woman%20with%20neat%20updo%20and%20reserved%20smile%2C%20silk%20blouse%2C%20soft%20studio%20lighting%2C%20warm%20neutral%20background%2C%20editorial%20photography%2C%20high%20detail&width=600&height=800&seq=cast-yazhi-08&orientation=portrait',
    roleDesc:
      '周明轩的母亲，讲究分寸、要求严格的婆婆。最初对苏念的到来颇有微词，在相处中逐渐被她的善良打动，态度悄然转变。',
    bio: '实力女演员，擅长演绎气场强大又不失温度的长辈角色。台词功底扎实，表演细腻有张力。',
    works: '代表作品：《门第》《望族》《庭院深深》',
    episodes: [5, 11, 15, 18, 20, 24],
  },
];

export const recommendations: Recommendation[] = [
  {
    id: 'rec-1',
    title: '暖阳小巷',
    poster:
      'https://readdy.ai/api/search-image?query=Warm%20cinematic%20poster%20of%20a%20quiet%20sunlit%20old%20alley%20with%20laundry%20lines%20and%20potted%20plants%2C%20soft%20golden%20afternoon%20light%2C%20nostalgic%20warm%20tone%2C%20film%20photography%2C%20high%20detail&width=600&height=900&seq=rec-poster-01&orientation=portrait',
    summary: '一条老巷子里三代同堂的平凡日常，用小事讲尽人间温暖。',
    reason: '同样的家庭群像与邻里温情，节奏舒缓治愈，看《善良的小姨子》之后最顺的续杯。',
    year: '2023',
    genre: '都市 / 家庭',
  },
  {
    id: 'rec-2',
    title: '春分以后',
    poster:
      'https://readdy.ai/api/search-image?query=Cinematic%20poster%20of%20a%20young%20woman%20standing%20by%20a%20bright%20window%20in%20spring%2C%20blooming%20branches%20outside%2C%20soft%20natural%20light%2C%20gentle%20warm%20palette%2C%20film%20photography%2C%20high%20detail&width=600&height=900&seq=rec-poster-02&orientation=portrait',
    summary: '一个女孩在陌生城市重新出发的成长记，笑中带泪。',
    reason: '主角同样是初入都市的年轻人，成长线与苏念的经历高度共鸣。',
    year: '2022',
    genre: '都市 / 成长',
  },
  {
    id: 'rec-3',
    title: '回家的方向',
    poster:
      'https://readdy.ai/api/search-image?query=Cinematic%20poster%20of%20a%20rural%20road%20leading%20home%20at%20dusk%20with%20a%20small%20house%20in%20the%20distance%2C%20warm%20sunset%20light%2C%20nostalgic%20earth%20tones%2C%20film%20photography%2C%20high%20detail&width=600&height=900&seq=rec-poster-03&orientation=portrait',
    summary: '关于亲情与和解的故事，一封信牵出两代人的心结。',
    reason: '与剧中父女和解、姐妹相守的情感主线一脉相承。',
    year: '2023',
    genre: '家庭 / 情感',
  },
  {
    id: 'rec-4',
    title: '街角的咖啡店',
    poster:
      'https://readdy.ai/api/search-image?query=Cozy%20cinematic%20poster%20of%20a%20small%20corner%20cafe%20with%20warm%20string%20lights%20at%20dusk%2C%20steaming%20coffee%20cups%2C%20soft%20amber%20glow%2C%20film%20photography%2C%20high%20detail&width=600&height=900&seq=rec-poster-04&orientation=portrait',
    summary: '两个年轻人在合租与创业中相识相知，轻松又治愈。',
    reason: '喜欢苏念与陆则言合租线的话，这部轻喜剧会非常对味。',
    year: '2024',
    genre: '都市 / 轻喜剧',
  },
  {
    id: 'rec-5',
    title: '妈妈的菜谱',
    poster:
      'https://readdy.ai/api/search-image?query=Cinematic%20poster%20of%20a%20rustic%20kitchen%20table%20filled%20with%20home%20cooked%20Chinese%20dishes%2C%20warm%20soft%20light%2C%20cozy%20domestic%20atmosphere%2C%20film%20photography%2C%20high%20detail&width=600&height=900&seq=rec-poster-05&orientation=portrait',
    summary: '用一道道家常菜串起一个家庭的聚散与牵挂。',
    reason: '同样以饭桌与日常小事承载情感，温暖细腻，后劲很足。',
    year: '2022',
    genre: '家庭 / 美食',
  },
  {
    id: 'rec-6',
    title: '深夜编辑部',
    poster:
      'https://readdy.ai/api/search-image?query=Cinematic%20poster%20of%20a%20late%20night%20office%20with%20desk%20lamps%20glowing%20through%20large%20windows%2C%20city%20lights%20outside%2C%20moody%20warm%20tone%2C%20film%20photography%2C%20high%20detail&width=600&height=900&seq=rec-poster-06&orientation=portrait',
    summary: '几个年轻人在城市深夜里为理想奔波的故事。',
    reason: '周明轩式职场困局与年轻人的坚持，在这部剧里有另一种延续。',
    year: '2023',
    genre: '都市 / 职场',
  },
];